import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const priorityConfig: Record<string, { label: string; className: string }> = {
  low: { label: "Low", className: "bg-gray-100 text-gray-500 border-transparent dark:bg-gray-800/50 dark:text-gray-400" },
  medium: { label: "Medium", className: "bg-blue-50 text-blue-500 border-transparent dark:bg-blue-900/20 dark:text-blue-400" },
  high: { label: "High", className: "bg-amber-50 text-amber-500 border-transparent dark:bg-amber-900/20 dark:text-amber-400" },
  urgent: { label: "Urgent", className: "bg-red-50 text-red-500 border-transparent dark:bg-red-900/20 dark:text-red-400" },
};

interface PriorityBadgeProps {
  priority: string | null;
  className?: string;
}

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  if (!priority) return null;
  const config = priorityConfig[priority];
  if (!config) return null;
  return (
    <Badge
      variant="outline"
      className={cn("no-default-hover-elevate no-default-active-elevate", config.className, className)}
      data-testid="task-priority-badge"
    >
      {config.label}
    </Badge>
  );
}

export const PRIORITY_OPTIONS = [
  { value: "none", label: "None" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
] as const;
